import React, { useState, useEffect} from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useTheme  } from '../../context/ThemeContext';
import './landingPage.css';
import temisLight from '../../images/landingLight.png';
import temisDark from '../../images/landingDark.png';
import megaphoneL from '../../images/megaphoneL.png';
import megaphoneD from '../../images/megaphoneD.png';
import justiceLight from '../../images/justiceLight.png';
import justiceDark from '../../images/justiceDark.png';
import xLight from '../../images/xLight.png'; 
import xDark from '../../images/xDark.png'; 
import igLight from '../../images/igLight.png'; 
import igDark from '../../images/igDark.png'; 

const TemisLandingPage = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activeSection, setActiveSection] = useState('inicio');
  const navigate = useNavigate();
  const { isDarkMode, themeClass, toggleTheme } = useTheme();

  const login = () => {
    navigate('/login');
  };
  const signup = () => {
    navigate('/signup2');
  };
  const manual = () => {
    navigate('/manual');
  };
  const politica = () => {
    navigate('/politica');
  };

  useEffect(() => {
      document.body.className = isDarkMode ? 'dark-theme' : 'light-theme';
      localStorage.setItem('theme', isDarkMode ? 'dark' : 'light');
  }, [isDarkMode]);

  useEffect(() => {
    const handleScroll = () => {
      const sections = ['inicio', 'quees', 'porque', 'comienza'];
      const scrollPosition = window.scrollY + window.innerHeight / 4; 
      
      let currentSection = 'inicio'; 
      
      
      for (const sectionId of sections) {
        const element = document.getElementById(sectionId);
        if (element) {
          const elementTop = element.offsetTop;
          const elementBottom = elementTop + element.offsetHeight;
          
          
          if (scrollPosition >= elementTop && scrollPosition < elementBottom) {
            currentSection = sectionId;
            break;
          }
        }
      }
      
      setActiveSection(currentSection);
    };

    
    let timeoutId;
    const debouncedHandleScroll = () => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(handleScroll, 10);
    };

    window.addEventListener('scroll', debouncedHandleScroll);
    
    // Llamada inicial
    handleScroll();
    
    return () => {
      window.removeEventListener('scroll', debouncedHandleScroll);
      clearTimeout(timeoutId);
    };
  }, []);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      setActiveSection(sectionId);
      
      element.scrollIntoView({ 
        behavior: 'smooth',
        block: 'start'
      });
    }
  };

  return (
    <div className={`landing-container ${themeClass}`}>
      {/* Header Navigation */}
      <header className={`header ${themeClass}`}>
        {/* Menú Hamburguesa */}
        <div 
          className={`hamburger-menu ${isMobileMenuOpen ? 'active' : ''}`}
          onClick={toggleMobileMenu}
        >
          <div className={`hamburger-line ${themeClass}`}></div>
          <div className={`hamburger-line ${themeClass}`}></div>
          <div className={`hamburger-line ${themeClass}`}></div>
        </div>

        {/* Toggle de Tema */}
        <div className="header-left">
          <div className="theme-toggle">
            <span className="colorIconToggle" >☼</span>
            <label className="toggle-switch">
              <input
                type="checkbox"
                checked={isDarkMode}
                onChange={toggleTheme}
                className="toggle-input"
              />
              <span className={`toggle-slider ${themeClass}`}>
                <span className={`toggle-knob ${themeClass}`} />
              </span>
            </label>
            <span className="colorIconToggle">☽</span>
          </div>
        </div>

        {/* Navegación Desktop */}
        <nav className="nav">
          <div className={`nav-link ${themeClass}`} onClick={signup}>
            Regístrate
          </div>
          <p className={`nav-txt ${themeClass}`}>
            o bien,
          </p>
          <button className={`login-button  ${themeClass}`} onClick={login}>
            Inicia sesión
          </button>
        </nav>

        {/* Navegación Móvil */}
        <nav className={`mobile-nav ${themeClass} ${isMobileMenuOpen ? 'open' : ''}`}>
          <Link to="/signup2" className={`mobile-nav-link ${themeClass}`} onClick={signup}>Registrarse</Link>
          <Link to="/login" className={`mobile-nav-link ${themeClass}`} onClick={login}>Iniciar sesión</Link>
          <Link to="/manual" className={`mobile-nav-link ${themeClass}`} onClick={manual}>Manual</Link>
          <Link to="/politica" className={`mobile-nav-link ${themeClass}`} onClick={politica}>Políticas de usuario</Link>
        </nav>

      </header>

      {/* Menú Lateral Izquierdo */}
      <nav className={`side-menu ${themeClass}`}>
        <ul className="side-menu-list">
          <li>
            <button 
              className={`side-menu-item ${themeClass} ${activeSection === 'quees' ? 'active' : ''}`}
              onClick={() => scrollToSection('quees')}
            >
              ¿Qué es?
            </button>
          </li>
          <li>
            <button 
              className={`side-menu-item ${themeClass} ${activeSection === 'porque' ? 'active' : ''}`}
              onClick={() => scrollToSection('porque')}
            >
              ¿Por qué?
            </button>
          </li>
          <li>
            <button 
              className={`side-menu-item ${themeClass} ${activeSection === 'comienza' ? 'active' : ''}`}
              onClick={() => scrollToSection('comienza')}
            >
              Comienza
            </button>
          </li>
        </ul>
      </nav>

      {/* Main Content */}
      <main className="main-content">
        <section id="inicio">
          <div className="logo-section">
            <img 
              src={isDarkMode ? temisDark : temisLight} 
              alt="Temis Logo" 
              className="imgTemis"
            />
          </div>

        {/* Description Text */}
        <div className='desc'>
          <p className={`description ${themeClass}`}> Obtén asesoría legal precisa y segura en segundos gracias a la inteligencia artificial de Temis.</p>
        </div>

            {/* CTA Button */}
            <button className={`cta-button ${themeClass}`} onClick={login}>
              Comenzar
            </button>
        </section>

        {/* Sección Qué es */}
        <section id="quees" className="section">
          <h2 className={`section-title ${themeClass}`}>¿Qué es?</h2>
          <div className="section-content">
            <p className={`section-text ${themeClass}`}>
              Asistente legal inteligente
            </p>
            <div className={`vertical ${themeClass}`}/>
            <p className={`section-description ${themeClass}`}>
              Resuelvemos tus consultas legales al instante. Rápido, preciso y basado en la ley guatemalteca. 
              Tu asistente legal digital, ¡siempre a tu servicio!
            </p>
          </div>
        </section>

        {/* Sección Por qué */}
        <section id="porque" className="section">
          <h2 className={`section-title ${themeClass}`}>¿Por qué Temis?</h2>
          <div className="why-grid">
            <div className={`why-card ${themeClass}`}>
              <h3 className={`why-card-title ${themeClass}`}>Inmediato y certero</h3>
              <div className={`why-line ${themeClass}`}/>
              <p className={`why-card-text ${themeClass}`}>
                Temis elimina la necesidad de navegar horas por textos legales, proporcionando respuestas claras y precisas al instante.
              </p>
            </div>
            <div className={`why-card ${themeClass}`}>
              <h3 className={`why-card-title ${themeClass}`}>Acceso automatizado</h3>
              <div className={`why-line ${themeClass}`}/>
              <p className={`why-card-text ${themeClass}`}>
                Simplifica la consulta legal con una experiencia intuitiva y automatizada.
              </p>
            </div>
          </div>
        </section>

        {/* Sección Respuestas Legales Instantáneas */}
        <section id="respuestasLegales" className="section">
          <div className="instant-legal-content">
            <div className="instant-legal-left">
              <h2 className={`instant-title ${themeClass}`}>
                Obtén respuestas legales instantáneas
              </h2>
              <p className={`instant-description ${themeClass}`}>
                Realiza cualquier consulta legal y recibe respuestas claras, precisas y 
                respaldadas por el marco legal de Guatemala. Todo esto desde la comodidad de 
                tu dispositivo.
              </p>
            </div>
            <img 
              src={isDarkMode ? megaphoneD : megaphoneL} 
              alt="Megáfono" 
              className="megaphone-image"
            />
          </div>
        </section>

        {/*Sección Optimiza tu tiempo*/}
        <section id="Optimizar" className="section">
          <div className="optimizar-content">
            <div className="instant-legal-right">
                  <div className={`legal-card ${themeClass}`}>
                    <div className="legal-card-image">
                      <img 
                        src={isDarkMode ? justiceDark : justiceLight} 
                        alt="Figura de la justicia" 
                        className="justice-image"
                      />
                    </div>
                    
                    <div className="card-content">
                      <h3 className={`card-title ${themeClass}`}>Optimiza tu Tiempo</h3>
                      <p className={`card-text ${themeClass}`}>
                        Con Temis, evita perder tiempo buscando en documentos legales extensos. 
                        Deja que nuestra inteligencia artificial encuentre lo que necesitas en segundos
                      </p>
                    </div>
                  </div>
                </div>
          </div>
        </section>
            
        {/* Sección Comienza */}
        <section id="comienza" className="section">
          <h2 className={`section-titleStart ${themeClass}`}>¡Activa tu apoyo legal inteligente!</h2>
          <div className="start-content">
            <button className={`color-button ${themeClass}`} onClick={login}>
              Comenzar
            </button>
            <button className={`politicas color-button red ${themeClass}`}  onClick={politica}>
              Políticas de uso
            </button>
            <button className={`color-button blue ${themeClass}`}  onClick={manual}>
              Manual
            </button>
          </div>
        </section>

        {/* Redes */}
        <div className='mediaIcons'>
          <img 
            src={isDarkMode ? xDark  : xLight} 
            alt="twitter" 
            className="social"
            onClick={() => window.open("https://twitter.com/temisgpt", "_blank")}
          />
          <img 
            src={isDarkMode ? igDark : igLight} 
            alt="instagram" 
            className="social"
            onClick={() => window.open("https://www.instagram.com/temis.ia/", "_blank")}
            
          />
        </div>
      </main>
    </div>
  );
};

export default TemisLandingPage;